export default [
  {
    path: '/coupon-list',
    name: 'couponList',
    component: () => import('../../pages/coupon/couponList.vue'),
    meta: {
      title: '我的优惠券'
    }
  },
  {
    path: '/choose-coupon',
    name: 'chooseCoupon',
    component: () => import('../../pages/coupon/couponSelect.vue'),
    meta: {
      title: '选择优惠券'
    }
  },
  {
    path: '/search-coupon-goods',
    name: 'searchCouponGoods',
    component: () => import('../../pages/drugVenue/couponGoods.vue'),
    meta: {
      title: '使用优惠券'
    }
  }
];
